import PropTypes from "prop-types";
import { memo } from "react";
import classNames from "classnames";
import "./separator.scss";

const Separator = ({ design = "left", margin = "wide" }) => {
	const separatorClassName = classNames({
		separator: true,
		"separator--wide-margin": margin === "wide",
		"separator--narrow-margin": margin === "narrow",
		"separator--left": design === "left",
		"separator--left-white": design === "left-white",
		"separator--middle": design === "middle",
		"separator--middle-dark": design === "middle-dark",
		"separator--full": design === "full",
		"separator--full-dark": design === "full-dark",
	});

	return <div className={separatorClassName} data-testid="separator" />;
};

Separator.propTypes = {
	design: PropTypes.oneOf(["left", "left-white", "middle", "middle-dark", "full-dark", "full"]),
	margin: PropTypes.oneOf(["wide", "narrow"]),
};

export default memo(Separator);
